// lat: -0.2480777
// lng: -78.5262284
import React, { Component } from 'react';
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';
import '../css/editLocation.css';
import 'whatwg-fetch';

const MAX_RADIUS_M = 300; // radio permitido en metros (ajusta si deseas)

class EditLocation extends Component {
  constructor(props) {
    super(props);

    // refs / instancias nativas
    this.map = null;
    this.google = null;
    this.markerRef = null;   // ref del <Marker> del wrapper
    this.marker = null;      // instancia nativa google.maps.Marker
    this.circle = null;      // google.maps.Circle
    this.listeners = [];     // listeners de marker/map para limpiar al desmontar
    this.detachMapLockListeners = null; // función para limpiar listeners del mapa
    this.initialCenterLatLng = null;

    this.state = {
      name: this.props.name,
      referencia: this.props.reference,
      center: { lat: this.props.lat, lng: this.props.lng },
      markerPos: { lat: this.props.lat, lng: this.props.lng },
      mapStyles: [
        { featureType: 'all', elementType: 'labels', stylers: [{ visibility: 'on' }] },
        { featureType: 'poi', stylers: [{ visibility: 'on' }] },
        { featureType: 'poi.business', stylers: [{ visibility: 'on' }] },
        { featureType: 'poi.government', stylers: [{ visibility: 'on' }] },
        { featureType: 'poi.medical', stylers: [{ visibility: 'on' }] },
        { featureType: 'poi.park', stylers: [{ visibility: 'on' }] },
        { featureType: 'poi.place_of_worship', stylers: [{ visibility: 'on' }] },
        { featureType: 'poi.school', stylers: [{ visibility: 'on' }] },
        { featureType: 'poi.sports_complex', stylers: [{ visibility: 'on' }] },
        { featureType: 'road', stylers: [{ visibility: 'on' }] },
        { featureType: 'transit', stylers: [{ visibility: 'on' }] },
        { featureType: 'water', stylers: [{ visibility: 'on' }] },
        { featureType: 'administrative', stylers: [{ visibility: 'on' }] },
        { featureType: 'landscape', stylers: [{ visibility: 'on' }] }
      ]
    };
  }

  // Handlers de inputs
  inputChangedHandlerText1 = (e) => this.setState({ name: e.target.value });
  inputChangedHandlerText2 = (e) => this.setState({ referencia: e.target.value });

  // POST con tu API
  getaddAddress = () => {
    const url = this.props.dir_url + 'webapp/addNewUbication';
    const token = this.props.token;
    const token_Client = this.props.token_Client;
    const { lat, lng } = this.state.markerPos;
    const referencia = this.state.referencia;
    const calle = this.state.name;

    const obj = { accion: 'newubication', token, token_Client, lat, lng, referencia, calle };
    this.props.get_loading(true);

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' }
    })
      .then((res) => res.json())
      .then((data) => {
        if (data[0]?.status === 'ok') {
          this.props.get_loading(false);
          this.props.get_finalice_to(lat, lng, calle, Number(data[0].msg), referencia);
        }
      })
      .catch(console.log);
  };

  // ------------------ MAPA ------------------

  onMapReady = (mapProps, map) => {
    this.google = mapProps.google;
    this.map = map;

    // Centro inicial (LatLng nativo)
    this.initialCenterLatLng = new this.google.maps.LatLng(
      this.state.center.lat,
      this.state.center.lng
    );

    // Círculo visible del radio permitido
    if (this.circle) { this.circle.setMap(null); this.circle = null; }
    this.circle = new this.google.maps.Circle({
      map: this.map,
      center: this.initialCenterLatLng,
      radius: MAX_RADIUS_M,
      strokeColor: '#FF0000',
      strokeOpacity: 0.8,
      strokeWeight: 1,
      fillColor: '#FF0000',
      fillOpacity: 0.12,
      clickable: false
    });

    // Bloqueo de paneo: si el mapa intenta moverse (auto-pan incluido), re-centramos
    this.attachMapLockListeners();

    // Engancha listeners del marcador (se monta un poco después)
    window.setTimeout(this.attachMarkerListeners, 0);
  };

  attachMapLockListeners = () => {
  const g = this.google;
  if (!g || !this.map || !this.initialCenterLatLng) return;

  // Limpiar listeners anteriores
  if (this.detachMapLockListeners) {
    this.detachMapLockListeners();
  }

  // Forma PRO de bloquear paneo sin bloquear zoom
  // ---------------------------------------------------
  // 1. Evitar drag manual
  const dragstart = g.maps.event.addListener(this.map, "dragstart", (e) => {
    this.map.setOptions({ draggable: false });
  });

  // 2. Evitar PAN por cualquier motivo (gestos, marker drag, autoscroll)
  const panstart = g.maps.event.addListener(this.map, "panstart", () => {
    this.map.panTo(this.initialCenterLatLng); // devolver al centro
  });

  // 3. center_changed se usa solo para evitar auto-pan “silencioso”
  const center_fix = g.maps.event.addListener(this.map, "center_changed", () => {
    const c = this.map.getCenter();
    const allowed = this.initialCenterLatLng;

    // Si se movió aunque sea 0.1m -> regresarlo sin animación
    if (!c.equals(allowed)) {
      this.map.setCenter(allowed);
    }
  });

  // 4. Evita tilt/rotate (movimiento indeseado)
  this.map.setOptions({
    gestureHandling: "greedy",
    draggable: false,
    tilt: 0,
    heading: 0,
    rotateControl: false
  });

  // Limpieza segura
  this.detachMapLockListeners = () => {
    g.maps.event.removeListener(dragstart);
    g.maps.event.removeListener(panstart);
    g.maps.event.removeListener(center_fix);
    this.detachMapLockListeners = null;
  };
};

  /**
   * Obtiene la instancia nativa del marker y le engancha listeners 'drag'/'dragend'
   * para aplicar el límite duro en tiempo real.
   */
  attachMarkerListeners = () => {
    if (!this.markerRef || !this.markerRef.marker || !this.google) return;

    // Instancia nativa
    this.marker = this.markerRef.marker;

    // Limpia listeners previos del marker
    this.detachMarkerListeners();

    const g = this.google;
    const centerLatLng = this.initialCenterLatLng;

    const clampToRadius = (candidateLatLng) => {
      const dist = g.maps.geometry.spherical.computeDistanceBetween(centerLatLng, candidateLatLng);
      if (dist <= MAX_RADIUS_M) return candidateLatLng;
      const heading = g.maps.geometry.spherical.computeHeading(centerLatLng, candidateLatLng);
      return g.maps.geometry.spherical.computeOffset(centerLatLng, MAX_RADIUS_M, heading);
    };

    // DRAG continuo: si se pasa, lo reponemos al borde YA
    const dragListener = g.maps.event.addListener(this.marker, 'drag', () => {
      const pos = this.marker.getPosition();
      const clamped = clampToRadius(pos);
      if (!pos.equals(clamped)) this.marker.setPosition(clamped);
      // Si el drag del marker induce auto-pan, el lock del mapa lo recentra
    });

    // DRAGEND: sincroniza estado y vuelve a corregir por si acaso
    const dragendListener = g.maps.event.addListener(this.marker, 'dragend', () => {
      const pos = this.marker.getPosition();
      const clamped = clampToRadius(pos);
      if (!pos.equals(clamped)) this.marker.setPosition(clamped);
      const p = this.marker.getPosition();
      this.setState({ markerPos: { lat: p.lat(), lng: p.lng() } });
    });

    this.listeners = [dragListener, dragendListener];
  };

  // Limpia listeners del marker
  detachMarkerListeners = () => {
    if (this.google && this.google.maps && this.google.maps.event && this.listeners && this.listeners.length) {
      this.listeners.forEach((ln) => this.google.maps.event.removeListener(ln));
    }
    this.listeners = [];
  };

  componentWillUnmount() {
    this.detachMarkerListeners();
    if (this.detachMapLockListeners) {
      this.detachMapLockListeners();
    }
    if (this.circle) { this.circle.setMap(null); this.circle = null; }
  }

  render() {
    const mapOptions = {
      styles: this.state.mapStyles,
      // Mapa congelado: sin zoom ni paneo por gestos
      gestureHandling: 'greedy', // permite zoom con pinch y scroll
      draggable: false,          // NO permitir paneo
      zoomControl: true,         // permitir el control +/-
      scrollwheel: true,
      disableDoubleClickZoom: false,
      keyboardShortcuts: false,
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: false
    };

    return (
      <div className="modal-dialog-new-ubication">
        <div className="modal-content-new-ubication">
          <div className="grid-container-menu-new-ubication">
            <div className="div_menu_1-new-ubication">
              <img
                className="icon-global"
                alt="Cargando Imagen . . ."
                src={require('../image/12355707351582004488-128.png')}
                onClick={() => this.props.get_go_to('')}
              />
            </div>
            <div className="lbl_menu_2-new-ubication">
              <span className="span-global-link">Seleccione su Ubicación</span>
            </div>
          </div>

          <div className="grid-container-menu-new-ubication-map">
            <Map
              google={this.props.google}
              style={{ width: '90%', height: '300px', left: '5px', right: '5px', position: 'relative' }}
              initialCenter={this.state.center}
              center={this.state.center}
              zoom={17}
              minZoom={15}
              maxZoom={20}
              options={mapOptions}
              onReady={this.onMapReady}
            >
              <Marker
                ref={(r) => (this.markerRef = r)}
                position={this.state.markerPos}
                draggable={true} // solo el pin se puede arrastrar
              />
            </Map>
          </div>

          <div className="grid-container-menu-new-ubication">
            <div className="div_menu_1-new-ubication">
              <img
                className="icon-global"
                alt="Cargando Imagen . . ."
                src={require('../image/15808962761582004492-128.png')}
                onClick={() => this.props.get_go_to('')}
              />
            </div>
            <div className="lbl_menu_2-new-ubication">
              <input
                style={{ width: '80%' }}
                className="input-global"
                placeholder="Direccion"
                value={this.state.name}
                onChange={this.inputChangedHandlerText1}
              />
            </div>
          </div>

          <div className="grid-container-menu-new-ubication">
            <div className="div_menu_1-new-ubication">
              <img
                className="icon-global"
                alt="Cargando Imagen . . ."
                src={require('../image/2198796101582004488-128.png')}
                onClick={() => this.props.get_go_to('')}
              />
            </div>
            <div className="lbl_menu_2-new-ubication">
              <input
                style={{ width: '80%' }}
                className="input-global"
                placeholder="Referencia"
                value={this.state.referencia}
                onChange={this.inputChangedHandlerText2}
              />
            </div>
          </div>

          <div className="grid-container-menu-new-ubication-map">
            <button style={{ width: '150px' }} className="button-global" onClick={this.getaddAddress}>
              LISTO
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyAhGBIYFLkWPbqHVQ_kHj3nWwrkDiiFUXg',
  libraries: ['places', 'geometry'] // imprescindible
})(EditLocation);
